module.exports = __webpack_public_path__ + "img/banner-watch.0ff46d20.png";